<div (click)="alterState(); ToggleSportNav(); setCurrentSport();" class="league-item-container">
  <div class="league-name">{{fixture?.fixtureName}}</div>
</div>